import { queriesPayers } from "@query";
import { Payer } from "@wingspanhq/wingspan-api-sdk";

import { ContextItem, RequirementTableItemData } from "../../../../types";

export const getRequirementPayerFromCache = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem
): Payer | undefined => {
  return queriesPayers.getPayer.getQueryData({
    payerId: requirement.payerAccountId ?? ""
  });
};
